<template>
  <div>
    <!-- <div class="head">
      <h1 @click="navigateHome">格瑞电竞俱乐部</h1>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'SidebarSearch',
  methods: {
    // navigateHome() {
    //   if (this.$route.path !== '/') {
    //     this.$router.replace('/'); 
    //   }
    // },
  },
};
</script>

<style scoped>
/* .head {
  height: 11vw;
  display: flex;

  justify-content: space-between;
  border-bottom: 2px solid #854685;
  background-color: #0c0c0c;
}

.head p {
  margin: 4vw; 
  font-size: 4vw;
  color: #2c313c;
}

.head h1 {
  color: #e7e6e7;
  padding: 2.2vw 3vw; 
  font-family: "楷体";
  font-size: 6vw; 
} */
</style>
